import React from "react";
import { useIntl } from "react-intl";
import { messages } from "../FurtherMaterials.messages";
import styles from "../FurtherMaterials.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";

interface FurtherMaterials {
  title: string;
}

export const FurtherMaterialsWebsites: React.FC<FurtherMaterials> = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();
  return (
    <SimpleLayoutView>
      <div className={styles.FurtherMaterials}>
        <div className={styles.rightComponent}>
          <div className={styles.listsWrapper}>
            <div className={styles.lists}>
              <h4>{formatMessage(messages.G7_P4_G1_Title)}</h4>
              <ul>
                <li>
                  <span>{formatMessage(messages.G7_P4_G1_I1_Title)}</span>
                  <a href="{formatMessage(messages.G7_P4_G1_I1_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P4_G1_I1_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P4_G1_I2_Title)}</span>
                  <a href="{formatMessage(messages.G7_P4_G1_I2_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P4_G1_I2_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P4_G1_I3_Title)}</span>
                  <a href="{formatMessage(messages.G7_P4_G1_I3_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P4_G1_I3_Link)}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.infoBox}>
            <block.infoBox text={formatMessage(messages.G7_P4_Note)} compact={true} />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
